import { Injectable } from '@angular/core';
import { AccessoryTypeFilter } from '@project/components/article/model/accessory-type-filter';
import { AddArticlePresenter } from './add-article.presenter';
import { FavoriteArticlesFilter } from './favorite-articles-filter';
import { SearchQueryBuilder } from '../../../util/search-query-builder';
import { ConnectionCubeSearchHelper } from '@article/components/connections/connection-creation/search/connection-cube-search.helper';
import { UserModel } from '@user/model/user.model';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { AlternativeReplaceArticleManager } from '../manager/alternative-replace-article.manager';
import { DefaultReplaceArticleManager } from '../manager/default-replace-article.manager';
import { ArticleTypeManager } from '../manager/article-type.manager';
import { ArticleCreationManager } from '../manager/article-creation.manager';
import { AccessoryService } from '@article/service/accessory.service';

@Injectable({providedIn: 'root'})
export class AddArticlePresenterFactory {

  constructor(
    private connectionCubeSearchHelper: ConnectionCubeSearchHelper,
    private userModel: UserModel,
    private localeResourceManager: LocaleResourceManager,
    private alternativeReplaceArticleManager: AlternativeReplaceArticleManager,
    private defaultReplaceArticleManager: DefaultReplaceArticleManager,
    private articleTypeManager: ArticleTypeManager,
    private accessoryService: AccessoryService
  ) {
  }

  public create(articleCreationManager: ArticleCreationManager, initialFilter: AccessoryTypeFilter | undefined): AddArticlePresenter {
    return new AddArticlePresenter(
      articleCreationManager,
      new FavoriteArticlesFilter(this.userModel, this.articleTypeManager),
      new SearchQueryBuilder(this.connectionCubeSearchHelper),
      this.alternativeReplaceArticleManager,
      this.defaultReplaceArticleManager,
      this.localeResourceManager,
      this.accessoryService,
      initialFilter,
    );
  }

}
